import { render, staticRenderFns } from "./UserCreateEdit.vue?vue&type=template&id=046e251c&scoped=true&"
import script from "./UserCreateEdit.vue?vue&type=script&lang=js&"
export * from "./UserCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./UserCreateEdit.vue?vue&type=style&index=0&id=046e251c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046e251c",
  null
  
)

export default component.exports